/**
 * Route `/dag/$exerciseId` — joueur DAG « solve-backward » pour l'élève.
 * Accès gâté côté serveur (RPC get_dag_for_player réutilise le paywall V2) ;
 * accessible aussi aux tuteurs/admins pour tester (bypass de rôle dans le gating).
 */
import { useState } from 'react';
import { useNavigate, useParams } from '@tanstack/react-router';
import { DagPlayer } from '@/features/dag-player';

export function DagPlayerPage() {
  const { exerciseId } = useParams({ strict: false }) as { exerciseId: string };
  const navigate = useNavigate();
  // Bumper la clé remonte <DagPlayer/> → nouvelle tentative propre (« Recommencer »).
  const [replayKey, setReplayKey] = useState(0);

  return (
    <DagPlayer
      key={replayKey}
      exerciseId={exerciseId}
      onReplay={() => setReplayKey((k) => k + 1)}
      onExit={() => navigate({ to: '/student/dashboard' })}
    />
  );
}
